export class MfaVerifyViewModel {
	public MfaTypeName: string;
	public MfaInfoIconUrl: string;
	public MfaTypeTitle: string;
	public MfaTypeDescription: string;
	public HasOptionRequestNewCode: boolean;
	public HasOptionChooseOtherAuthenticators: boolean;
	public CodeAreaFootnoteText: string;
	public CodeChar1: string;
	public CodeChar2: string;
	public CodeChar3: string;
	public CodeChar4: string;
	public CodeChar5: string;
	public CodeChar6: string;
}
